import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEsLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 33,
	viewBox: "0 0 72 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1_26)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.60315 8.47974V11.1748H3.01725V14.5594H5.49573V17.2544H3.01725V20.8764H5.64622V23.5714H0V8.47974H5.60315Z",
				fill: "#114387"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.78355 8.47974V20.8764H11.9599V23.5714H6.7663V8.47974H9.78299H9.78355Z",
				fill: "#114387"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.9467 23.5708H12.93V8.47974H15.9467V23.5708Z",
				fill: "#114387"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7049 23.5709V11.1742H16.8732V8.47919H23.5539V11.1742H21.7222V23.5709H18.7055H18.7049Z",
				fill: "#114387"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51.2569 6.38694C51.0152 4.25274 47.0026 1.11664 45.9363 0.606183C45.8356 0.259718 45.7875 0.00448636 45.4204 0.00112806C41.8521 -0.0307758 39.3496 0.615698 36.9075 1.73121C36.0078 2.14205 35.5703 2.64691 35.1787 3.57492C34.9381 3.7322 32.6616 5.48748 32.1206 5.92462C31.5796 6.36176 32.3696 7.4297 32.75 7.87747C33.0124 8.18644 33.1998 8.3829 33.3386 8.48756C33.4768 8.59223 33.554 8.5385 34.0888 8.45286C34.3484 8.79709 35.05 9.3624 35.7482 9.33218C35.5597 9.19225 35.3879 8.66444 35.3572 8.33476C36.8856 8.19147 38.0673 9.05008 38.4662 9.91932C35.5905 9.50065 35.1518 10.0072 33.9669 10.7645C32.8742 11.4625 32.1178 11.5509 31.4324 11.0035C32.1161 13.5748 34.8335 11.3903 35.4534 11.2358C35.3846 12.2421 35.6324 12.9323 36.0817 13.3297C36.5393 12.7761 37.4216 12.4123 38.5803 12.3423L35.2173 15.7068H48.7667C49.9074 13.225 50.5005 10.7628 50.6773 9.38535C50.6969 9.43461 51.1422 9.84096 51.6301 9.87622C51.3923 9.054 51.5019 8.54857 51.2569 6.38806V6.38694ZM48.0209 10.7757C47.8586 9.86335 47.4329 8.78421 46.6983 8.24689C44.8973 12.1727 42.6477 11.8912 41.3609 14.8023C39.9572 12.0921 43.4455 11.5688 42.5783 8.34204L40.6671 10.254C41.3055 8.83403 41.5802 7.28081 40.694 6.21735C39.8223 5.17124 37.5699 5.30781 36.5119 5.98115C37.392 6.46475 38.1769 7.03062 38.6586 7.93736C37.0037 7.06364 35.031 7.20301 33.3184 7.77057C33.2468 7.70172 33.1719 7.61553 33.0969 7.51981C33.4124 7.16439 33.7917 6.41829 33.7224 6.18489C33.3492 6.50337 33.0007 6.76699 32.7058 6.9433C32.5872 6.7446 32.4815 6.54702 32.4043 6.38191C33.1545 5.80876 34.9045 4.42122 35.3633 4.07867C35.5658 3.66168 36.0319 2.93461 36.7715 2.57919C39.2259 1.39762 42.6113 0.88884 44.3373 0.878765C44.7356 2.80867 43.4522 4.50797 43.4444 4.53596C43.4679 3.8128 43.3493 2.55736 42.8547 2.02563C42.3707 2.06425 40.8176 2.32787 39.372 2.78404C42.3724 3.55645 43.5143 5.38617 43.9417 6.97801L47.0731 3.84527C47.815 5.25128 48.859 7.44257 48.0214 10.7757H48.0209ZM36.781 3.31354C36.4593 3.60851 36.1522 4.06188 36.014 4.48279C36.5623 4.56954 37.1973 4.79623 37.3204 4.86899C37.7657 3.90796 38.4869 3.26372 38.803 2.97659C38.1019 3.23014 37.6353 3.44507 36.8828 3.93482C36.8493 3.68519 36.8207 3.39525 36.7816 3.31354H36.781Z",
				fill: "#114387"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.0528 20.8758H27.4753V17.2539H29.9538V14.5594H27.4753V11.1742H30.0612V8.47974H24.4586V23.5708H27.3595L30.0528 20.8758Z",
				fill: "#114387"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.6663 17.4005V20.0239H42.1486V23.319H44.5611V25.9424H42.1486V29.4686H44.7082V32.092H39.2119V17.4005H44.6663Z",
				fill: "#114387"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M52.9314 27.0338V32.092H49.9942V27.0551C49.9942 26.6985 49.8263 26.5306 49.4699 26.5306H48.7359V32.0925H45.7986V17.4011H50.1833C52.0083 17.4011 52.9107 18.3033 52.9107 20.1297V22.963C52.9107 24.2223 52.4491 24.852 51.6519 25.1459C52.5538 25.3977 52.9314 25.9642 52.9314 27.0349V27.0338ZM49.4492 19.9606H48.7359V24.032H49.4492C49.8056 24.032 49.9734 23.8641 49.9734 23.5076V20.4851C49.9734 20.1286 49.8056 19.9606 49.4492 19.9606Z",
				fill: "#114387"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M57.0223 32.092H54.085V17.4005H57.0223V32.092Z",
				fill: "#114387"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M63.6929 17.4005V20.0239H61.1753V23.319H63.5877V25.9424H61.1753V29.4686H63.7349V32.092H58.2386V17.4005H63.6929Z",
				fill: "#114387"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.1472 32.092L67.2803 24.0959L67.3222 27.8314L67.3642 32.092H64.8258V17.4005H67.8258L69.5249 24.683L69.4829 20.4437L69.4617 17.4005H72V32.092H69.1467H69.1472Z",
				fill: "#114387"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.0093 24.4731L34.4917 22.6053C34.1353 22.3534 33.9881 22.1228 33.9881 21.6611V20.2758C33.9881 19.9187 34.156 19.7507 34.5124 19.7507H34.7429C35.0992 19.7507 35.2671 19.9187 35.2671 20.2758V22.6893H38.1411V20.0026C38.1411 18.1768 37.2392 17.274 35.4137 17.274H33.8192C33.761 17.274 33.7034 17.2751 33.6474 17.2768L31.0951 19.8302C31.0934 19.8867 31.0923 19.9438 31.0923 20.002V22.3316C31.0923 23.3811 31.3647 23.9895 32.2672 24.6404L34.7848 26.5082C35.1412 26.7601 35.2884 26.9907 35.2884 27.4525V29.2156C35.2884 29.5727 35.1205 29.74 34.7641 29.74H34.4917C34.1353 29.74 33.9674 29.5721 33.9674 29.2156V26.361H31.0934V29.4881C31.0934 31.3139 31.9953 32.2168 33.8208 32.2168H35.4573C37.2823 32.2168 38.1848 31.3145 38.1848 29.4881V26.7808C38.1848 25.6893 37.9117 25.1229 37.0099 24.472L37.0093 24.4731Z",
				fill: "#114387"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1_26",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 72,
			height: 32.2179,
			fill: "white"
		})
	}) })]
});
export default SvgEsLogo;
